import React from 'react';

import { Typography } from '@mui/material';

import { definitions } from '@luxuryescapes/contract-svc-promo';

type Props = {
  conditionType: definitions['RuleJson']['conditions'][0]['conditionType'];
};

const PromoDisplayConditionType = ({ conditionType }: Props) => {
  switch (conditionType) {
    case 'gt':
      return <Typography variant="body2"> &gt; </Typography>;
    case 'neq':
      return <Typography variant="body2"> != </Typography>;
    case 'eq':
      return <Typography variant="body2"> = </Typography>;
    case 'lt':
      return <Typography variant="body2"> &lt; </Typography>;
    default:
      return <Typography variant="body2">Unknown ({conditionType})</Typography>;
  }
};

export default PromoDisplayConditionType;
